import { Pipe, PipeTransform } from "@angular/core";
import { formatNumber } from "@ponder-shared/utils/numberFormatter";

@Pipe({
    name: 'number',
    standalone: true
})
export class FormatNumberPipe implements PipeTransform {
    constructor() {

    }

    public transform(value: string | number | undefined): string {
        return formatNumber(+value!);
    }
}